import "./TradeSimulatorViewComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit, ITimeoutService} from "angular";
import {Simulation} from "../models/Simulation";
import {Observable, ReplaySubject, Subject} from "rxjs";
import {Optional} from "../../js/util/Optional";
import {TradeSimulatorViewStore} from "../service/TradeSimulatorViewStore";

export const TradeSimulatorView = "tfTradeSimulator";

export function tradeSimulatorView(): IComponentOptions {
    return {
        templateUrl: "app/trade-simulator/view/TradeSimulatorViewComponent.html",
        controllerAs: "ctrl",
        bindings: {
            viewStore: "<"
        },
        controller: TradeSimulatorViewComponentController
    };
}

export class TradeSimulatorViewComponentController implements IOnInit, IOnDestroy {

    public viewStore: TradeSimulatorViewStore;
    public simulations: Observable<Simulation[]>;
    public newSimulationTabId = -1;
    public activeTab = this.newSimulationTabId;
    public filter = "";

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private $timeout: ITimeoutService) {
    }

    public $onInit(): void {
        this.viewStore
            .currentSimulation
            .takeUntil(this.destroyed$)
            .subscribe(this.updateActiveTab.bind(this));

        this.simulations = this.viewStore.simulations
                               .takeUntil(this.destroyed$);
    }

    private updateActiveTab(simulation: Simulation | null) {
        const tab = Optional.of(simulation)
                            .map((sim) => sim.id)
                            .orElse(this.newSimulationTabId);
        if (this.activeTab !== tab) {
            this.$timeout(() => this.activeTab = tab);
        }
    }

    public deleteSimulation($event: JQueryEventObject, simulation: Simulation) {
        $event.preventDefault();
        $event.stopPropagation();
        this.viewStore.delete(simulation.id);
    }

    public deleteAllSimulations() {
        this.viewStore.deleteAll();
    }

    public simulationSelected(simulation: Simulation | null) {
        const id = Optional.of(simulation)
                           .map((sim) => sim.id)
                           .orNull();
        this.viewStore.select(id);
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
        this.viewStore.stop();
    }
}
